module.exports = __webpack_public_path__ + "img/monastery-2.c9f82cdd.png";